type FormSetter = React.Dispatch<React.SetStateAction<any>>;

type WarrantyDeps = {
  setForm: FormSetter;
  callVendorLookup: (manufacturer: string, serialBase: string) => Promise<any>;
  buildWarrantyLink: (manufacturer: string, serialBase: string) => string | null;
  copyToClipboard: (text: string) => Promise<void>;
  focusSelector?: string;
};

type OpenWarrantyArgs = {
  manufacturer: string;
  serialBase: string;
  form: { model?: string | null; warrantyStartDate?: string | null };
  focusAfter?: boolean;
};

const focusWarrantyInput = (selector?: string) => {
  if (!selector) return;
  setTimeout(() => {
    document.querySelector<HTMLInputElement>(selector)?.focus();
  }, 100);
};

/**
 * Shared handlers for warranty lookup/open and "no warranty".
 */
export function createWarrantyActions({
  setForm,
  callVendorLookup,
  buildWarrantyLink,
  copyToClipboard,
  focusSelector,
}: WarrantyDeps) {
  const openWarranty = async ({ manufacturer, serialBase, form, focusAfter }: OpenWarrantyArgs) => {
    try { await copyToClipboard(serialBase); } catch { /* ignore */ }

    let url: string | null = null;
    try {
      const res = await callVendorLookup(manufacturer, serialBase);
      if (res?.ok && res.deepLink) url = res.deepLink;

      if (res?.model && !form.model) {
        setForm((p: any) => ({ ...p, model: res.model as string }));
      }
      if (res?.warrantyStartDate && !form.warrantyStartDate) {
        setForm((p: any) => ({ ...p, warrantyStartDate: res.warrantyStartDate as string }));
      }
    } catch { /* ignore */ }

    if (!url) url = buildWarrantyLink(manufacturer, serialBase);

    if (url) {
      const w = window.open(
        url,
        "vendorWarrantyPopup",
        "noopener,noreferrer,width=1200,height=900,left=80,top=60,scrollbars=1,resizable=1"
      );
      w?.focus?.();
    } else {
      alert("Kunde inte skapa garantilänk. Kontrollera tillverkare och serienummer.");
    }

    if (focusAfter) focusWarrantyInput(focusSelector);
  };

  const markNoWarranty = (focusAfter?: boolean) => {
    setForm((p: any) => ({ ...p, warrantyStartDate: "9999-99-99" }));
    if (focusAfter) focusWarrantyInput(focusSelector);
  };

  return { openWarranty, markNoWarranty };
}
